import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {ModalPortal} from "features/components/modal";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import {connect} from "react-redux";
import Button from "features/components/button";
import {hideAssociateModal, startAssociateCompany} from "features/modals/company/associate/reducer";
import {
    associateModalError,
    associateModalLoading
} from "features/modals/company/associate/selectors";
import {TextField} from "features/components/text-field";
import Select from "features/components/select";
import {COMPANY_ROLES} from "constants.js";
import {RequiredValidator} from "services/utils/validations";

/* istanbul ignore next */
const mapStateToProps = state => ({
    error: associateModalError(state),
    loading: associateModalLoading(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    hideAssociateModal,
    startAssociateCompany
};

export const AssociateCompanyModal = (props) => {
    const {hideAssociateModal, startAssociateCompany, error, loading} = props;

    const [companyName, setCompanyName] = useState("");
    const [secretCode, setSecretCode] = useState("");
    const [role, setRole] = useState("");

    const doAssociate = useCallback(() => {
        startAssociateCompany({companyName, secretCode, role});
    }, [companyName, secretCode, role, startAssociateCompany]);

    const doCancel = useCallback(() => {
        hideAssociateModal();
    }, [hideAssociateModal]);

    const buttonEnabled = useMemo(() => {
        return RequiredValidator(companyName) && RequiredValidator(secretCode) && RequiredValidator(role);
    }, [companyName, secretCode, role]);

    return <ModalPortal className={"associate-company-modal"}>
        <Title size={34} align={"center"}>{__("modal.associate-company.title")}</Title>
        <Text size={16} align={"center"}>{__("modal.associate-company.text")}</Text>
        <div className="form-field">
            <TextField
                type={"text"}
                value={companyName}
                onChange={setCompanyName}
                placeholder={__("modal.associate-company.company.placeholder")}
                hint={__("modal.associate-company.company.hint")}
            />
            <TextField
                type={"text"}
                value={secretCode}
                onChange={setSecretCode}
                placeholder={__("modal.associate-company.secret.placeholder")}
                hint={__("modal.associate-company.secret.hint")}
            />
            <Select
                value={role}
                values={COMPANY_ROLES.filter(i => i.assignable)}
                onChange={setRole}
                placeholder={__("modal.associate-company.role.placeholder")}
            />
        </div>
        {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
        <Button title={__("buttons.do-associate-company")} status={loading ? "loading" : null} disabled={!buttonEnabled} onClick={doAssociate} icon={"arrow-right"} />
        <Button title={__("buttons.cancel")} type={"outlined"} onClick={doCancel} />
    </ModalPortal>
};

export default connect(mapStateToProps, mapDispatchToProps)(AssociateCompanyModal);


